module.exports = __webpack_public_path__ + "static/media/sy.fce5d4b9.svg";